import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1244e047&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244e047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1244e047')) {
      api.createRecord('1244e047', component.options)
    } else {
      api.reload('1244e047', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1244e047&scoped=true", function () {
      api.rerender('1244e047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybsjdr/index.vue"
export default component.exports